import { pluralize, currency } from '../utils';
import { StyleCTA } from '../style_cta';
import { Amenity } from '../amenity';
import Slider from "react-slick";
import { stripLeadingZeros } from '../utils';

const Arrow = (props) => {
    const { className, style, onClick } = props;
    return (
        <svg className={ className } onClick={onClick} width="48" height="31" viewBox="0 0 48 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M32 15.7656L17 15.7656" />
            <path d="M21.75 10.7656C21.75 13.527 19.5114 15.7656 16.75 15.7656" />
            <path d="M21.75 20.7656C21.75 18.0042 19.5114 15.7656 16.75 15.7656" />
            <rect x="47.5" y="30.2656" width="46.25" height="29" rx="14.5" transform="rotate(-180 47.5 30.2656)" />
        </svg>
    );
}

const slickSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: true,
    fade: true,
    nextArrow: <Arrow className="slick-next" />,
    prevArrow: <Arrow className="slick-prev" />,
};

export function Card ({ unit, amenities }) {

    // list of amenities checked but not included in this unit
    const negativeAmenities = amenities.filter(( amenity ) => {
        return !unit.amenities.find(( item ) => item == amenity );
    });
    let amenitiesSection;
    if(negativeAmenities.length > 0 || unit.amenities.length > 0) amenitiesSection = (<div className="rentals-section__card__amenities">
        <div className="md:w-1/5 p-4 rentals-section__card__headline">
        Unit Features
        </div>
        <div className="md:w-4/5 p-4">
            { unit.amenities.map( ( amenity, index ) => (
                <Amenity key={ index } amenity={ amenity } amenities={ amenities }></Amenity>
            ))
            }
            { negativeAmenities.map( ( amenity, index ) => (
                <Amenity key={ index } amenity={ amenity } amenities={ amenities } negative></Amenity>
            ))
            }
        </div>
    </div>);

    let styleType = '';
    if(unit?.project?.fields?.card_overrides?.style) {
        styleType = <div className="rentals-section__card__type">{ unit?.project?.fields?.card_overrides?.style}</div>;
    }

    const imageGallery = () => {
        if(unit?.project?.fields?.image_gallery) {
            return(
                <Slider {...slickSettings}>
                    {unit.project.fields.image_gallery.map((image, index) => (
                        <img src={ image } key={ index } className="rentals-section__card__image" />
                    ))}
                </Slider>
            )
        } else if(unit?.project?.fields?.featured_image) {
            return (
                <img src={ unit?.project?.fields?.featured_image} className="rentals-section__card__image" />
            );
        }

        return(
            <img src='/app/themes/flipp/public/images/null-image-icon.svg' className="rentals-section__card__image" />
        )
    };

    return(
        <div className="rentals-section__card">
            <div className="rentals-section__card__image_holder">
                { imageGallery() }
                { styleType }
            </div>
            <div className="rentals-section__card__info">
                <div className="rentals-section__card__building">
                    { unit.property }
                </div>
                <div className="rentals-section__card__header">
                    <div className="rentals-section__card__name"><strong>#{ stripLeadingZeros(unit.apartmentName) }</strong><br />{ unit.floorplanName }</div>
                    <div className="rentals-section__card__cost"><span className="header-3">{ currency( unit.rent ) }</span>/mo</div>
                </div>
                <div className="rentals-section__card__calendar">
                    <div className="calendar-icon"></div>
                    { unit.dateShown }
                </div>

                <div className="rentals-section__card__features">
                    <div>
                        <strong>{ unit.sqft.toLocaleString() }</strong><br />
                        SqFt
                    </div>
                    <div>
                        <strong>{ unit.beds }</strong><br />
                        Bed
                    </div>
                    <div>
                        <strong>{ unit.baths }</strong><br />
                        Bath
                    </div>
                </div>
                <div className="rentals-section__card__cta-holder">
                    <StyleCTA unit={ unit }>See Details</StyleCTA>
                </div>
            </div>
            { amenitiesSection }
        </div>
    );
};